import { useEffect, useState } from "react";

const parse = (s) => Number(String(s).replace(/\./g, "").replace(",", ".")) || 0;
const show = (n, decimals) => (n === "" || n == null || Number(n) === 0 ? "" : Number(n).toLocaleString("id-ID", { maximumFractionDigits: decimals }));

const shape = (raw, decimals) => {
  const s = raw.replace(/[^\d,]/g, "");
  const cut = s.indexOf(",");
  let int = cut >= 0 ? s.slice(0, cut) : s;
  const dec = cut >= 0 && decimals ? s.slice(cut + 1).replace(/,/g, "").slice(0, decimals) : null;
  int = int.replace(/^0+(?=\d)/, "");
  const intFmt = int ? Number(int).toLocaleString("id-ID") : dec !== null ? "0" : "";
  return dec !== null ? `${intFmt},${dec}` : intFmt;
};

export default function NumInput({ value, onChange, decimals = 0, ...p }) {
  const [text, setText] = useState(show(value, decimals));
  useEffect(() => {
    if (parse(text) !== Number(value || 0)) { setText(show(value, decimals)); }
  }, [value]); // eslint-disable-line
  const change = (e) => {
    const t = shape(e.target.value, decimals);
    setText(t);
    onChange(parse(t));
  };
  return <input type="text" inputMode={decimals ? "decimal" : "numeric"} value={text} onChange={change} {...p} />;
}
